<div *ngIf="rowSlider" style="height: 36px; margin-right: 9px">
  <div class="flex gap-4 align-items-center">
    <input
      #rowSliderInput
      class="flex-1 p-inputtext p-inputtext-sm p-component p-element"
      style="height: 24px;"
      pInputText
      [(ngModel)]="rowsDisplayed"
      (ngModelChange)="syncMultiSelectFilterValue()"
      (focus)="rowSliderInput.select()"
      [disabled]="!!isLoading"
    />
    <app-stamo-slider
      class="flex-1"
      [(value)]="rowsDisplayed"
      [min]="rowSliderMin"
      [max]="rowSliderMax"
      (onSlideEnd)="syncMultiSelectFilterValue()"
      [disabled]="!!isLoading"
    ></app-stamo-slider>
  </div>
</div>
<div #chartContainer class="chart-row relative overflow-y-auto" [ngClass]="styleClass" [ngStyle]="{ height: height }" (mouseleave)="handleUnhover($event)">
  <app-chart-content-loader *ngIf="(isLoading !== undefined && isLoading) && (error !== undefined && !error)" [isLoading]="isLoading" [error]="error">
    <ng-template #loading>
      <app-chart-loading-row-basic [height]="+height.replace('px','')"></app-chart-loading-row-basic>
    </ng-template>
  </app-chart-content-loader>

  <ng-container *ngIf="!error && ((isLoading !== undefined && !isLoading) || (isLoading === undefined))">
    <!-- Striped Row Background -->
    <div
      class="absolute w-full"
      [ngStyle]="{ height: height }"
    >
      <div
        *ngFor="let d of chartData; let i = index"
        class="w-full chart-row-item"
        [ngStyle]="{
          height: d['height'],
          opacity: d['opacity'],
          backgroundColor: striped ? d['stripeColor'] : 'white',
        }"
        [ngClass]="{
          hovered: hoveredRow == d[rowIdKey] || hoveredRowIndex == i,
          unhovered: (hoveredRow !== null && hoveredRow != d[rowIdKey]) || (hoveredRowIndex !== null && hoveredRowIndex != i),
          selected: selectedRow == d[rowIdKey] || selectedRowIndex == i,
          unselected: (selectedRow !== null && selectedRow != d[rowIdKey]) || (selectedRowIndex !== null && selectedRowIndex != i)
        }"
      >
        <div
          *ngIf="showRank"
          class="chart-row-col rank-col pl-1 text-sm font-semibold cursor-pointer pl-1"
          [ngClass]="{
            selected: (selectedRow == d[rowIdKey] && selectedCol === 'rank') || (selectedRowIndex == i && selectedCol === 'rank')
          }"
          [ngStyle]="{
            width: d['rankColWidth'],
            height: useStaticBarHeight ? staticBarHeight : '100%'
          }"
          (click)="selectPart({ originalEvent: $event, row: d[rowIdKey], col: 'rank', data: d, index: i })"
          (mouseenter)="handleHover({ originalEvent: $event, row: d[rowIdKey], col: null, data: d, index: i })"
          (mousemove)="handleHoverMove({ originalEvent: $event, row: d[rowIdKey], col: null, data: d, index: i })"
          (mouseleave)="handleUnhover($event)"
        >
          {{ d['rank'] }}.
        </div>
      </div>
    </div>
    <!-- End of Striped Row Background -->

    <div
      class="relative"
      style="font-size: 14px"
      [ngStyle]="{
        height: height,
        marginLeft: this.showRank ? this.rankColWidth + 'px' : 0
      }"
    >
      <div
        *ngFor="let d of chartData; let i = index;"
        class="chart-row-item flex cursor-pointer mb-0"
        [ngStyle]="{
          height: d['height'],
          opacity: d['opacity'],
          transform: d['transform'],
          background: 'transparent'
        }"
        [ngClass]="{
          hovered: hoveredRow == d[rowIdKey] || hoveredRowIndex == i,
          unhovered: (hoveredRow !== null && hoveredRow != d[rowIdKey]) || (hoveredRowIndex !== null && hoveredRowIndex != i),
          selected: selectedRow == d[rowIdKey] || selectedRowIndex == i,
          unselected: (selectedRow !== null && selectedRow != d[rowIdKey]) || (selectedRowIndex !== null && selectedRowIndex != i)
        }"
        (mouseenter)="handleHover({ originalEvent: $event, row: d[rowIdKey], col: null, data: d, index: i })"
        (mousemove)="handleHoverMove({ originalEvent: $event, row: d[rowIdKey], col: null, data: d, index: i })"
        (mouseleave)="handleUnhover($event)"
      >
        <div
          *ngIf="showId"
          class="chart-row-col id-col px-2 text-sm"
          [ngStyle]="{
            width: d['idColWidth']
          }"
          [ngClass]="{
            selected: (selectedRow == d[rowIdKey] || selectedRowIndex == i) && selectedCol === 'id'
          }"
          (click)="selectPart({ originalEvent: $event, row: d[rowIdKey], col: 'id', data: d, index: i })"
        >
          {{ d['idLabel'] }}
        </div>
        <div
          *ngIf="showName"
          class="chart-row-col name-col pl-1 pr-2 text-sm"
          [ngStyle]="{
            width: d['nameColWidth']
          }"
          [ngClass]="{
            selected: (selectedRow == d[rowIdKey] || selectedRowIndex == i) && selectedCol === 'name'
          }"
          [attr.title]="d[valueLabelKey]"
          (click)="selectPart({ originalEvent: $event, row: d[rowIdKey], col: 'name', data: d, index: i })"
        >
          <div
            class="w-full"
            [ngClass]="nameStyleClass"
            [ngStyle]="{
              overflow: !multiline ? 'hidden' : 'initial',
              whiteSpace: !multiline ? 'nowrap' : 'normal',
              textOverflow: !multiline ? 'ellipsis' : 'initial',
              lineHeight: !multiline ? 'initial' : '1'
            }"
          >
            {{ d['nameLabel'] }}
          </div>
        </div>
        <div
          class="chart-row-col bar-col"
          [ngStyle]="{
            paddingTop: yPadding,
            paddingBottom: yPadding,
            opacity: (selectedRow !== null && selectedRow != d[rowIdKey]) || selectedRowIndex !== null && selectedRowIndex != i ? 0.3 : d['opacity']
          }"
          [ngClass]="{
            selected: (selectedRow == d[rowIdKey] || selectedRowIndex == i) && selectedCol === 'bar'
          }"
          (click)="selectPart({ originalEvent: $event, row: d[rowIdKey], col: 'bar', data: d, index: i })"
        >
          <div
            [ngStyle]="{
              width: d['width'],
              backgroundColor: d['backgroundColor']
            }"
            class="bar-box"
          ></div>
          <div
            *ngIf="!d[valuePctKey]"
            class="bar-text pl-2 text-800"
            [ngStyle]="{
              width: d['valueColWidth']
            }"
          >
            <ng-container
              [ngTemplateOutlet]="valueTemplate || valueTemplateDefault"
              [ngTemplateOutletContext]="{
                $implicit: d[valueKey],
                valueDisplay: d[valueKey + '_display']
              }"
            ></ng-container>
          </div>
          <div
            *ngIf="d[valuePctKey]"
            class="bar-text pl-2"
            [ngStyle]="{
              width: d['valueColWidth']
            }"
          >
            <div style="font-size: 12px; font-weight: bold; font-style: italic;">
              <ng-container
                [ngTemplateOutlet]="valueTemplate || valueTemplateDefault"
                [ngTemplateOutletContext]="{
                  $implicit: d[valueKey],
                  valueDisplay: d[valueKey + '_display']
                }"
              ></ng-container>
            </div>
            <div style="font-size: 11px; margin-top: -4.5px">
              <ng-container
                [ngTemplateOutlet]="valuePctTemplate || valuePctTemplateDefault"
                [ngTemplateOutletContext]="{
                  $implicit: d[valuePctKey],
                  sumSubMarketName: d['sum_sub_market_name'],
                  valuePctDisplay: d[valuePctKey + '_display']
                }"
              ></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #valueTemplateDefault let-value let-valueDisplay="valueDisplay">
  <span style="font-size: 11.5px;" [ngClass]="valueStyleClass">{{ valueDisplay ?? (value | numDE) }}</span>
</ng-template>
<ng-template #valuePctTemplateDefault let-valuePct let-valuePctDisplay="valuePctDisplay">
  <span style="font-size: 11.5px;" [ngClass]="valueStyleClass">{{ valuePctDisplay ?? (valuePct | pctNumDE) }}</span>
</ng-template>

<!-- Popup -->
<ng-container
  [ngTemplateOutlet]="popup?.tpl || null"
  [ngTemplateOutletContext]="{ controller: popupController, valueKey: valueKey, valuePctKey: valuePctKey }"
></ng-container>
<!-- End of popup -->
